module.exports = __webpack_public_path__ + "img/19.7f69f533.png";